import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaRegClock } from 'react-icons/fa';
import { useLanguage } from '../../../context/LanguageContext.js';
import ButtonWithLoader from '../../../components/Button/ButtonLoader/ButtonLoader.js';
import AuthBrand from '../AuthBrand/AuthBrand.jsx';

const SESSION_EXPIRED_STORAGE_KEY = 'aaa_dashboard_session_expired';

/**
 * Standalone page shown after session expiry (replaces inline notice on login).
 */
function SessionExpired() {
    const navigate = useNavigate();
    const { t } = useLanguage();

    useEffect(() => {
        sessionStorage.removeItem(SESSION_EXPIRED_STORAGE_KEY);
    }, []);

    return (
        <main className="auth-page">
            <AuthBrand corner to="/login" />
            <section>
                <div className="auth-shell container">
                    <div className="auth-card">
                        <div className="auth-session-expired">
                            <div className="auth-session-expired-icon-wrap" aria-hidden>
                                <FaRegClock className="auth-session-expired-icon" />
                            </div>
                            <h1 className="auth-session-expired-title">{t('auth.sessionExpired.title')}</h1>
                            <p className="auth-session-expired-message">
                                {t('auth.sessionExpired.message')}
                            </p>
                            <div className="auth-action-box auth-session-expired-actions">
                                <ButtonWithLoader
                                    text={t('auth.sessionExpired.submit')}
                                    type="button"
                                    onClick={() => navigate('/login')}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default SessionExpired;
